/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'successful': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M511.14 65.796c-246.628 0-446.56 199.596-446.56 445.813s199.932 445.813 446.56 445.813c246.63 0 446.559-199.596 446.559-445.813 0-246.216-199.927-445.813-446.56-445.813zM756.675 404.75L469.211 698.446c-13.225 13.512-34.679 13.512-47.901 0l-155.707-159.09c-13.232-13.513-13.232-35.426 0-48.943 13.224-13.518 34.679-13.518 47.901 0l131.757 134.611 263.505-269.22c13.233-13.518 34.689-13.518 47.911 0 13.233 13.515 13.233 35.43 0 48.946z" _fill="#00a854"/>'
  }
})
